import React, { useState, useRef } from 'react';
import styled from 'styled-components';
import { AcceptMethod, acceptMethod2text, CommunityType, communityType2text, ActivityType, activityType2text } from '../common/enums';
import { FiImage, FiCalendar } from 'react-icons/fi';
import { useNavigate, useLocation } from 'react-router-dom';
import { useNoobookContext } from '../context/NoobookContext';
import { useEffect } from 'react';
import SimpleCalendar from '../components/SimpleCalendar';
import { FaChevronRight } from 'react-icons/fa';
import { createBookcommunity, modifyBookcommunity, uploadBookCommunityImageToTmpFile, getBookcommunity } from '../api/BookcommunityApi';
import { BookcommunityInputReqDTO } from '../dto/BookcommunityDTOs';
import { getAccessToken } from '../react-queries/queries';
import { processApiResponse } from '../common/errorMessage';
import LoadingOverlay from '../components/LoadingOverlay';
import MessageModal from '../components/MessageModal';
import { stringToDate } from '../common/utils';

const PageWrapper = styled.div`
  max-width: 480px;
  margin: 0 auto;
  min-height: 100vh;
  background: #f5f5f5;
`;
const TabRow = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1.5px solid #e0e0e0;
  background: #eae8e9;
`;
const Tab = styled.button`
  flex: 1;
  background: none;
  border: none;
  font-size: 17px;
  font-weight: 600;
  color: ${props => props.active ? '#222' : '#bdbdbd'};
  border-bottom: ${props => props.active ? '3px solid #222' : 'none'};
  padding: 14px 0 10px 0;
  cursor: pointer;
`;
const ContentSection = styled.div`
  background: #fff;
  padding: 32px 20px 120px 20px;
`;
const ContentTitle = styled.div`
  font-size: 22px;
  font-weight: 700;
  color: #404040;
  margin-bottom: 24px;
`;
const FormRow = styled.div`
  display: flex;
  align-items: center;
  margin-top: 24px;
  margin-bottom: 0;
  gap: 0;
`;
const FormLabel = styled.div`
  flex: 0 0 110px;
  font-size: 15px;
  color: #444;
  font-weight: 400;
  text-align: left;
  display: flex;
  align-items: center;
`;
const FormInput = styled.input`
  flex: 1;
  height: 36px;
  border: 1px solid #e1e1e1;
  background: #f7f7f7;
  border-radius: 0;
  font-size: 16px;
  padding: 0 10px;
  box-sizing: border-box;
`;
const FormTextArea = styled.textarea`
  flex: 1;
  min-height: 80px;
  border: 1px solid #e1e1e1;
  background: #f7f7f7;
  border-radius: 0;
  font-size: 16px;
  padding: 8px 10px;
  resize: none;
  box-sizing: border-box;
`;
const FormValue = styled.div`
  flex: 1;
  font-size: 16px;
  color: #444;
  text-align: left;
`;
const FormArrow = styled.span`
  margin: 0 8px;
  color: #bbb;
`;
const SearchInputWrapper = styled.div`
  position: relative;
  flex: 1;
  width: 100%;
`;
const SearchIcon = styled(FiImage)`
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #bbb;
  cursor: pointer;
`;
const SearchInput = styled(FormInput)`
  padding-left: 32px;
  width: 100%;
  box-sizing: border-box;
`;
const ImageUploadBox = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;
  background: none;
  color: #888;
  font-size: 14px;
  cursor: pointer;
  height: 36px;
  padding-left: 12px;
`;
const ButtonContainer = styled.div`
  display: flex;
  gap: 12px;
  margin: 40px 0 0 0;
  justify-content: center;
`;

const RegisterButton = styled.button`
  flex: 1;
  max-width: 200px;
  background: #244AC2;
  color: #fff;
  font-size: 18px;
  border: none;
  border-radius: 24px;
  padding: 14px 0;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(36,74,194,0.08);
  transition: background 0.15s;
  font-weight: 500;
  &:active {
    background: #193a99;
  }
`;

const CancelButton = styled.button`
  flex: 1;
  max-width: 200px;
  background: #9e9e9e;
  color: #fff;
  font-size: 18px;
  border: none;
  border-radius: 24px;
  padding: 14px 0;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(158,158,158,0.08);
  transition: background 0.15s;
  font-weight: 500;
  &:active {
    background: #757575;
  }
`;
const HashTagInput = styled.input`
  flex: 1;
  height: 36px;
  border: 1px solid #e1e1e1;
  background: #f7f7f7;
  border-radius: 0;
  font-size: 16px;
  padding: 0 10px;
  box-sizing: border-box;
`;
const HashTagTable = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
`;
const HashTagItem = styled.div`
  background: #eae8e9;
  color: #244ac2;
  border-radius: 16px;
  padding: 6px 14px 6px 12px;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 4px;
`;
const RemoveTagBtn = styled.button`
  background: none;
  border: none;
  color: #888;
  font-size: 16px;
  cursor: pointer;
  margin-left: 2px;
`;

const Selector = styled.div`
  flex: 1;
  height: 36px;
  border: 1px solid #e1e1e1;
  background: #f7f7f7;
  border-radius: 0;
  font-size: 14px;
  padding: 0 10px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  color: #444;
`;

const ArrowIcon = styled(FaChevronRight)`
  font-size: 13px;
  color: #bbb;
`;

const Dropdown = styled.div`
  position: relative;
  display: inline-block;
`;

const DropdownButton = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  color: #555;
  font-weight: 500;
  cursor: pointer;
  min-width: 80px;
  font-size: 14px;
`;

const DropdownList = styled.div`
  position: absolute;
  left: 0;
  background: #fff;
  border: 1px solid #eee;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  z-index: 10;
  min-width: 180px;
  ${({ position }) => position === 'top' && 'bottom: 110%; top: auto;'}
  ${({ position }) => position === 'bottom' && 'top: 110%;'}
`;

const DropdownItem = styled.div`
  padding: 10px 18px;
  color: #555;
  font-size: 15px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  &:hover {
    background: #f5f5f7;
  }
  &.selected {
    color: #1976d2;
    font-weight: 700;
  }
`;

export default function MoimCreatePage({ editBookCommunityId, onClose }) {
  const [tab, setTab] = useState('recommend');
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
 
  if(!editBookCommunityId) {
    editBookCommunityId = params.get('bookCommunityId');
  }
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [closePage, setClosePage] = useState(false);
  const [bookCommunityId, setBookCommunityId] = useState(editBookCommunityId);
  const [communityTitle, setCommunityTitle] = useState('');
  const [communityImageFile, setCommunityImageFile] = useState(null);
  const [communityType, setCommunityType] = useState(CommunityType.ONLINE);
  const [activityType, setActivityType] = useState(ActivityType.BOOK_REVIEW);
  const [briefIntroduction, setBriefIntroduction] = useState('');
  const [recruitNum, setRecruitNum] = useState(0);
  //const [recruitTo, setRecruitTo] = useState(new Date());
  const [membershipFee, setMembershipFee] = useState('');
  const [paymentInfo, setPaymentInfo] = useState('');
  const fileInputRef = useRef(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [hashTag, setHashTag] = useState('');
  const [hashTags, setHashTags] = useState([]);
  const [deadlineDate, setDeadlineDate] = useState('');
  const [showDeadlineCal, setShowDeadlineCal] = useState(false);
  const deadlineCalRef = useRef(null);
  const [acceptMethod, setAcceptMethod] = useState(AcceptMethod.ADMIN_APPROVAL);
  const [showParticipationDropdown, setShowParticipationDropdown] = useState(false);
  const participationDropdownRef = useRef(null);
  const [participationDropdownPosition, setParticipationDropdownPosition] = useState('bottom');
  const { showBack, setShowBack } = useNoobookContext();

  // 모임유형 드롭다운 관련 상태 추가
  const [showCommunityTypeDropdown, setShowCommunityTypeDropdown] = useState(false);
  const communityTypeDropdownRef = useRef(null);
  const [communityTypeDropdownPosition, setCommunityTypeDropdownPosition] = useState('bottom');

  // 모임 활동유형 드롭다운 관련 상태 추가
  const [showActivityTypeDropdown, setShowActivityTypeDropdown] = useState(false);
  const activityTypeDropdownRef = useRef(null);
  const [activityTypeDropdownPosition, setActivityTypeDropdownPosition] = useState('bottom');

  useEffect(() => {
    const prevShowBack = showBack;
    setShowBack(!onClose);
    if(editBookCommunityId) {
      console.log('editBookCommunityId', editBookCommunityId);
    }
    loadData();
    return () => setShowBack(prevShowBack);

  }, []);

  // 참여 방법 드롭다운 외부 클릭 시 닫기
  useEffect(() => {
    function handleClick(e) {
      if (participationDropdownRef.current && !participationDropdownRef.current.contains(e.target)) {
        setShowParticipationDropdown(false);
      }
    }
    if (showParticipationDropdown) {
      document.addEventListener('mousedown', handleClick);
    } else {
      document.removeEventListener('mousedown', handleClick);
    }
    return () => document.removeEventListener('mousedown', handleClick);
  }, [showParticipationDropdown]);

  // 모임유형 드롭다운 외부 클릭 시 닫기 useEffect 추가
  useEffect(() => {
    function handleClick(e) {
      if (communityTypeDropdownRef.current && !communityTypeDropdownRef.current.contains(e.target)) {
        setShowCommunityTypeDropdown(false);
      }
    }
    if (showCommunityTypeDropdown) {
      document.addEventListener('mousedown', handleClick);
    } else {
      document.removeEventListener('mousedown', handleClick);
    }
    return () => document.removeEventListener('mousedown', handleClick);
  }, [showCommunityTypeDropdown]);


  // 모임 활동유형 드롭다운 외부 클릭 시 닫기 useEffect 추가
  useEffect(() => {
    function handleClick(e) {
      if (activityTypeDropdownRef.current && !activityTypeDropdownRef.current.contains(e.target)) {
        setShowActivityTypeDropdown(false);
      }
    }
    if (showActivityTypeDropdown) {
      document.addEventListener('mousedown', handleClick);
    } else {
      document.removeEventListener('mousedown', handleClick);
    }
    return () => document.removeEventListener('mousedown', handleClick);
  }, [showActivityTypeDropdown]);


  const loadData = async () => {
    if(loading) {
      return;
    }
    setLoading(true);
    try {
      await loadBookCommunityInfo(false);
    } catch (error) {
      //setErrorMessage(error.message);
    } finally {
      setLoading(false);
    }
  }

  const loadBookCommunityInfo = async (needLoading) => {
    if(needLoading && loading) {
      return;
    }
    if(needLoading) {
      setLoading(true);
    }
    try {
      if(bookCommunityId) {
        const {accessToken} = await getAccessToken();
        const resp = await getBookcommunity(accessToken, bookCommunityId);
        const processedResp = processApiResponse(resp);
        if(!processedResp.success) {
          setErrorMessage(processedResp?.errMessage);
          setClosePage(true);
          return;
        }
        console.log('processedResp.data', processedResp.data);
        setCommunityTitle(processedResp.data?.title);
        setCommunityType(processedResp.data?.communityType);
        setActivityType(processedResp.data?.activityType);
        setBriefIntroduction(processedResp.data?.briefIntroduction);
        setRecruitNum(processedResp.data?.recruitNum);
        setDeadlineDate(processedResp.data?.recruitTo);
        setAcceptMethod(processedResp.data?.acceptMethod);
        setMembershipFee(processedResp.data?.membershipFee);
        setPaymentInfo(processedResp.data?.paymentInfo);
        setHashTags(processedResp.data?.hashtags);
        setPreviewUrl(processedResp.data?.imgUrl);
        setCommunityImageFile(null);
      }
    } catch (error) {
      setErrorMessage(error.message);
      setClosePage(true);
    } finally {
      if(needLoading) {
        setLoading(false);
      }
    }
  }


  const handleCloseErrorModal = () => {
    setErrorMessage('');
    if(closePage) {
      if(onClose) {
        onClose(false);
      } else {
        navigate(-1);
      }
    }
  };

  // 참여 방법 드롭다운 위치 계산
  const handleParticipationDropdown = () => {
    if (!participationDropdownRef.current) return setShowParticipationDropdown(v => !v);
    const rect = participationDropdownRef.current.getBoundingClientRect();
    const popupHeight = 180;
    if (window.innerHeight - rect.bottom < popupHeight) {
      setParticipationDropdownPosition('top');
    } else {
      setParticipationDropdownPosition('bottom');
    }
    setShowParticipationDropdown(v => !v);
  };

  // 모임유형 드롭다운 핸들러 추가
  const handleCommunityTypeDropdown = () => {
    if (!communityTypeDropdownRef.current) return setShowCommunityTypeDropdown(v => !v);
    const rect = communityTypeDropdownRef.current.getBoundingClientRect();
    const popupHeight = 120;
    if (window.innerHeight - rect.bottom < popupHeight) {
      setCommunityTypeDropdownPosition('top');
    } else {
      setCommunityTypeDropdownPosition('bottom');
    }
    setShowCommunityTypeDropdown(v => !v);
  };

   // 모임유형 드롭다운 핸들러 추가
   const handleActivityTypeDropdown = () => {
    if (!activityTypeDropdownRef.current) return setShowActivityTypeDropdown(v => !v);
    const rect = activityTypeDropdownRef.current.getBoundingClientRect();
    const popupHeight = 120;
    if (window.innerHeight - rect.bottom < popupHeight) {
      setActivityTypeDropdownPosition('top');
    } else {
      setActivityTypeDropdownPosition('bottom');
    }
    setShowActivityTypeDropdown(v => !v);
  };

  //const participationMethods = ['관리자 승인 후 참여', '선착순 마감', '신청 후 자동 승인'];
  const acceptMethods = [AcceptMethod.ADMIN_APPROVAL];
  const handleFileInputClick = () => {
    if (fileInputRef.current) fileInputRef.current.click();
  };
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setCommunityImageFile(file);
      const url = URL.createObjectURL(file);
      setPreviewUrl(url);
    }
  };
  const handleHashTagAdd = (e) => {
    e.preventDefault();
    const tag = hashTag.trim();
    if (tag && !hashTags.includes(tag)) {
      setHashTags([...hashTags, tag]);
      setHashTag('');
    }
  };
  const handleHashTagRemove = (tag) => {
    setHashTags(hashTags.filter(t => t !== tag));
  };

  // 등록하기 버튼 핸들러 함수 추가
  const handleRegister = async () => {
    if (loading) return;
    
    // authToken 획득
    const { accessToken } = await getAccessToken();
    if (!accessToken) {
      setErrorMessage('로그인이 필요합니다.');
      return;
    }
    
    setLoading(true);
    
    try {
      // 폼 데이터 검증
      if (!communityTitle.trim()) {
        setErrorMessage('모임명을 입력해주세요.');
        setLoading(false);
        return;
      }
      
      if (!briefIntroduction.trim()) {
        setErrorMessage('모임 소개를 입력해주세요.');
        setLoading(false);
        return;
      }
      
      if (recruitNum <= 0) {
        setErrorMessage('모집인원을 입력해주세요.');
        setLoading(false);
        return;
      }
      
      if (!deadlineDate) {
        setErrorMessage('모집 마감일을 선택해주세요.');
        setLoading(false);
        return;
      }

      let communityImageFileId = null;
      if(communityImageFile) {
        const tmpImageResp = await uploadBookCommunityImageToTmpFile(accessToken, communityImageFile);
        const processedImageResp = processApiResponse(tmpImageResp);
        if(!processedImageResp.success) {
          setErrorMessage(processedImageResp?.errorMessage);
          return;
        }
        communityImageFileId = processedImageResp.data?.fileId;
        console.log('communityImageFileId', communityImageFileId);
      }
      
      // BookcommunityInputReqDTO 객체 생성
      const reqDto = new BookcommunityInputReqDTO();
      reqDto.title = communityTitle;
      reqDto.communityType = communityType;
      reqDto.activityType = activityType;
      reqDto.tmpImageId = communityImageFileId;
      reqDto.briefIntroduction = briefIntroduction;
      reqDto.recruitNum = recruitNum;
      reqDto.recruitTo = deadlineDate ? stringToDate(deadlineDate, 'yyyy.mm.dd', '.') : null;
      reqDto.acceptMethod = acceptMethod;
      reqDto.hashtags = hashTags;
      reqDto.membershipFee = membershipFee;
      reqDto.paymentInfo = paymentInfo;
      
      // API 호출
      let response;
      if (bookCommunityId) {
        // 수정 모드
        response = await modifyBookcommunity(accessToken, parseInt(bookCommunityId), reqDto);
      } else {
        // 생성 모드
        response = await createBookcommunity(accessToken, reqDto);
      }

      const processedResponse = processApiResponse(response);
      if (processedResponse.success) {
        console.log(bookCommunityId ? '모임이 수정되었습니다.' : '모임이 등록되었습니다.');
        if(onClose) {
          onClose(true);
        } else {
          navigate(-1); // 모임 목록 페이지로 이동
        }
      } else {    
        setErrorMessage(processedResponse.message || '오류가 발생했습니다.');
        return;
      }
      
    } catch (error) {
      console.error('모임 등록/수정 오류:', error);
      setErrorMessage('오류가 발생했습니다. 다시 시도해주세요.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageWrapper>
      <TabRow>
        <Tab active={tab==='review'} >서평·필사단</Tab>
        <Tab active={tab==='recommend'}>추천모임</Tab>
      </TabRow>
      
        <ContentSection>
        {!onClose && <ContentTitle>모임 등록하기</ContentTitle> }
        
        {/* 모임유형 드롭다운 추가 */}
        <FormRow>
          <FormLabel>모임유형</FormLabel>
          <Dropdown ref={communityTypeDropdownRef}>
            <DropdownButton onClick={handleCommunityTypeDropdown}>
              {communityType2text(communityType) || '모임유형 선택'}
              <ArrowIcon />
            </DropdownButton>
            {showCommunityTypeDropdown && (
              <DropdownList position={communityTypeDropdownPosition}>
                {Object.values(CommunityType).map(type => (
                  <DropdownItem
                    key={type}
                    className={communityType === type ? 'selected' : ''}
                    onClick={() => {
                      setCommunityType(type);
                      setShowCommunityTypeDropdown(false);
                    }}
                  >
                    {communityType2text(type)}
                  </DropdownItem>
                ))}
              </DropdownList>
            )}
          </Dropdown>
        </FormRow>

        <FormRow>
          <FormLabel>모임 활동 유형</FormLabel>
          <Dropdown ref={activityTypeDropdownRef}>
            <DropdownButton onClick={handleActivityTypeDropdown}>
              {activityType2text(activityType) || '모임 활동 유형 선택'}
              <ArrowIcon />
            </DropdownButton>
            {showActivityTypeDropdown && (
              <DropdownList position={activityTypeDropdownPosition}>
                {Object.values(ActivityType).map(type => (
                  <DropdownItem
                    key={type}
                    className={activityType === type ? 'selected' : ''}
                    onClick={() => {
                      setActivityType(type);
                      setShowActivityTypeDropdown(false);
                    }}
                  >
                    {activityType2text(type)}
                  </DropdownItem>
                ))}
              </DropdownList>
            )}
          </Dropdown>
        </FormRow>
        
        <FormRow>
          <FormLabel>모임명</FormLabel>
          <FormInput placeholder="" value={communityTitle} onChange={e => setCommunityTitle(e.target.value)}/>
        </FormRow>
        <FormRow>
          <FormLabel>모임 대표 이미지</FormLabel>
          <ImageUploadBox onClick={handleFileInputClick}>
            <FiImage size={18} style={{marginRight:4, color:'#1976d2'}} />
            이미지 파일 업로드하기
          </ImageUploadBox>
          <input type="file" ref={fileInputRef} style={{display:'none'}} accept="image/*" onChange={handleFileChange} />
          {previewUrl && (
            <img src={previewUrl} alt="미리보기" style={{marginTop:12, maxWidth:'100%', maxHeight:120, border:'1px solid #eee', borderRadius:8}} />
          )}
        </FormRow>
        <FormRow>
          <FormLabel>모임 소개</FormLabel>
          <FormTextArea placeholder="모임의 목적과 방향성을 입력해주세요." value={briefIntroduction} onChange={e => setBriefIntroduction(e.target.value)} />
        </FormRow>
        {/* 해시태그 입력란 */}
        <FormRow>
          <FormLabel>해시태그</FormLabel>
          <form style={{flex:1, display:'flex'}} onSubmit={handleHashTagAdd}>
            <HashTagInput
              placeholder="태그 입력 후 Enter"
              value={hashTag}
              onChange={e => setHashTag(e.target.value)}
              maxLength={20}
            />
          </form>
        </FormRow>
        {/* 해시태그 테이블 */}
        {hashTags.length > 0 && (
          <HashTagTable>
            {hashTags.map(tag => (
              <HashTagItem key={tag}>
                #{tag}
                <RemoveTagBtn type="button" onClick={()=>handleHashTagRemove(tag)}>×</RemoveTagBtn>
              </HashTagItem>
            ))}
          </HashTagTable>
        )}
        <FormRow>
          <FormLabel>모집 마감일</FormLabel>
          <div style={{position:'relative'}} ref={deadlineCalRef}>
            <FormValue 
              style={{
                display: 'flex', 
                alignItems: 'center', 
                gap: '8px', 
                cursor: 'pointer',
                fontSize: '14px'
              }}
              onClick={() => setShowDeadlineCal(v => !v)}
            >
              {deadlineDate || '모집 마감일 선택'}
              <FiCalendar size={16} color="#bbb" />
            </FormValue>
            {showDeadlineCal && (
              <SimpleCalendar
                value={deadlineDate}
                onSelect={setDeadlineDate}
                onClose={() => setShowDeadlineCal(false)}
                anchorRef={deadlineCalRef}
              />
            )}
          </div>
        </FormRow>
        <FormRow>
          <FormLabel>모집인원</FormLabel>
          <FormInput type="number" min="1" placeholder="" value={recruitNum} onChange={e => setRecruitNum(e.target.value)} />
        </FormRow>
        {/*<FormRow>
          <FormLabel>필수 활동</FormLabel>
          <FormInput placeholder="" value={mission} onChange={e => setMission(e.target.value)} />
        </FormRow>*/}
        <FormRow>
          <FormLabel>참여 방법</FormLabel>
          <Dropdown ref={participationDropdownRef}>
            <DropdownButton onClick={handleParticipationDropdown}>
              {acceptMethod2text(acceptMethod) || '참여 방법 선택'}
              <ArrowIcon />
            </DropdownButton>
            {showParticipationDropdown && (
              <DropdownList position={participationDropdownPosition}>
                {acceptMethods.map(method => (
                  <DropdownItem
                    key={method}
                    className={acceptMethod === method ? 'selected' : ''}
                    onClick={() => {
                      setAcceptMethod(method);
                      setShowParticipationDropdown(false);
                    }}
                  >
                    {acceptMethod2text(method)}
                  </DropdownItem>
                ))}
              </DropdownList>
            )}
          </Dropdown>
        </FormRow>
        <FormRow>
          <FormLabel>회비</FormLabel>
          <FormInput placeholder="" value={membershipFee} onChange={e => setMembershipFee(e.target.value)} />
        </FormRow>
        <FormRow>
          <FormLabel>결재 정보</FormLabel>
          <FormInput placeholder="" value={paymentInfo} onChange={e => setPaymentInfo(e.target.value)} />
        </FormRow>
        <ButtonContainer>
        <RegisterButton onClick={handleRegister} disabled={loading}>
          {bookCommunityId ? '수정하기' : '등록하기'}
        </RegisterButton>
          <CancelButton onClick={() => onClose ? onClose(false) : navigate(-1)}>취소</CancelButton>
        </ButtonContainer>
      </ContentSection>
      {/* 에러 메시지 모달 */}
      <MessageModal
        isOpen={!!errorMessage}
        message={errorMessage}
        onClose={handleCloseErrorModal}
        title="오류"
      />
      {/* Loading 상태일 때 LoadingOverlay 표시 */}
      {loading && <LoadingOverlay />}
    </PageWrapper>
  );
} 